// Same hex convention as ObservabilityLayout's chartPalettes.agents
const PALETTE = ['#2563eb', '#0891b2', '#16a34a', '#f59e0b', '#7c3aed', '#db2777'];

function hashToIndex(key: string, mod: number): number {
  let hash = 2166136261;
  for (let i = 0; i < key.length; i++) {
    hash ^= key.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0) % mod;
}

export interface MemberAvatarProps {
  email: string;
  userId: string;
}

export function MemberAvatar({ email, userId }: MemberAvatarProps) {
  const color = PALETTE[hashToIndex(userId, PALETTE.length)];
  const initials = email.slice(0, 2).toUpperCase();

  return (
    <div
      className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-semibold text-white"
      style={{ backgroundColor: color }}
    >
      {initials}
    </div>
  );
}
